export default __webpack_public_path__ + "card_en.a190c18a.png";